// AUTO-GENERATED by scripts/ts/generate-builtin-script-metadata.ts
// Imports and default icon are derived from the matching .raw.js file.
// Safe to edit — this file will not be overwritten once it exists.
import { BuiltInScriptMetadata } from "../builtInsTypes";
import { SavedSpellAspect } from "src/api/spells";

const metadata: BuiltInScriptMetadata = {
  name: "Earth Spike",
  id: "earth-spike",
  metadata: {
    aspect: SavedSpellAspect.Earth,
    imports: ["earth","shapes","vector","wait","self","air"],
    icon: {
      "backgroundColor": 2434310,
      "layers": [
        {
          "iconKey": "earthSpike",
          "position": {
            "x": 0,
            "y": 0
          },
          "scale": 0.95,
          "rotation": 1,
          "color": 12296303
        },
        {
          "iconKey": "air",
          "position": {
            "x": 14,
            "y": -3
          },
          "scale": 0.57,
          "rotation": 7,
          "color": 16775423
        },
        {
          "iconKey": "delay",
          "position": {
            "x": -14,
            "y": 0
          },
          "scale": 0.6,
          "rotation": -17,
          "color": 16770542
        }
      ]
    },
  },
};

export default metadata;
